<template>
    <b-modal ref="mdlEditDataGruppo" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Impegnativa</label>
                <b-form-select :options="impegnativaOptions" value-field="value" text-field="text" v-model="jsonData.codiceFlussoImpegnativa">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona un'impegnativa - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Prestazioni</label>
                <b-form-select v-model="jsonData.idPrestazione">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona una prestazione - </b-form-select-option>
                    </template>
                    <b-form-select-option v-for="item in prestazioneOptions" :value="item.id" :key="item.id">{{ item.codicePrestazione }} - {{ item.nome }} </b-form-select-option>
                </b-form-select>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onSaveImpegnativaGruppoPrestazione">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            isRequired: false,
            pathResource: "/rsaimpegnativagruppoprestazione",
            pathResourceTipoImpegnativa: "/rsaimpegnativatipo",
            pathResourceTipoPrestazione: "/rsatipoprestazioni",
            impegnativaOptions: [],
            prestazioneOptions: [],

            jsonData: {
                id: null,
                codiceFlussoImpegnativa: null,
                idPrestazione: null,
            },
        };
    },
    methods: {
        show(jsonData) {
            let me = this;
            me.jsonData = jsonData;
            me.title = !jsonData.id ? "Nuovo gruppo" : "Aggiorna gruppo";
            me.loadTipoImpegnativaData();
            me.loadTipoPrestazioneData();
            me.$refs.mdlEditDataGruppo.show();
        },
        loadTipoImpegnativaData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTipoImpegnativa, null, me.loadTipoImpegnativaDataSuccess, me.loadTipoImpegnativaDataError);
        },

        loadTipoImpegnativaDataSuccess(response) {
            let me = this;
            //me.impegnativaOptions
            if (response.data && response.data.data && response.data.data.list) {
                me.impegnativaOptions = response.data.data.list.map((item) => ({
                    value: item.id,
                    text: item.tipo || item.id,
                }));
            } else {
                me.prestazioneOptions = [];
                console.warn("lista prestazione vuota");
            }
        },
        loadTipoImpegnativaDataError(error) {
            error;
            this.$bvToast.toast("Errore nel caricamento dei profili", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        loadTipoPrestazioneData() {
            let me = this;
            //let dashboardSearchBean = { limit: 0, page: 0 };
            UtilityMixin.methods.loadDataResources(me.pathResourceTipoPrestazione, null, me.loadTipoPrestazioneDataSuccess, me.loadTipoPrestazioneDataError);
        },
        loadTipoPrestazioneDataSuccess(response) {
            let me = this;
            /* me.prestazioneOptions = response.data.data.list; */
            if (response.data && response.data.data && response.data.data.list) {
                me.prestazioneOptions = response.data.data.list;
            } else {
                me.prestazioneOptions = [];
                console.warn("lista prestazione vuota");
            }
            // console.log("prestazioniOptions nel modalEdit: ", this.prestazioneOptions);
        },

        loadTipoPrestazioneDataError(error) {
            console.error("Errore durante il caricamento delle prestazione:", error);
            this.$bvToast.toast("Errore nel caricamento delle prestazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        onCloseModal() {
            let me = this;
            me.jsonData = {
                id: null,
                codiceFlussoImpegnativa: null,
                idPrestazione: null,
            };
            me.$refs.mdlEditDataGruppo.hide();
            me.$emit("closeModal");
        },

        onSaveImpegnativaGruppoPrestazione() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.impegnativaGruppoPrestazioneSuccessSave, me.impegnativaGruppoPrestazioneErrorSave);
        },
        impegnativaGruppoPrestazioneSuccessSave(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlEditDataGruppo.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        impegnativaGruppoPrestazioneErrorSave(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },

        onDeleteGruppoAssocizione(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo gruppo?", {
                    title: "Eliminazione Gruppo Associzione",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteGruppoAssociazione(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        deleteGruppoAssociazione(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteGruppoAssociazioneSuccess, me.deleteGruppoAssociazioneError);
        },
        deleteGruppoAssociazioneSuccess(response) {
            let me = this;
            me.$emit("deleteGruppoAssociazione", response);
            console.log("----");

            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteGruppoAssociazioneError(response) {
            let me = this;
            me.$emit("deleteGruppoAssociazione", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
